import React, { useEffect, useState, useContext } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import appointmentFormStyle from "../styles";
import { useFormikContext } from "formik";
import { CheckboxField } from "../../FormFields";
import { SchedulerContext } from "../../../context/schedulerContext";

const DiagnosticFeeStep = (props) => {
  const classes = appointmentFormStyle();
  const {
    setIsNextdisabled,
    isChecked,
    setIschecked,
    _handleNext,
    _handleBack,
    clickMode,
  } = props;
  const { setFieldValue, values } = useFormikContext();
  const { schedulerData } = useContext(SchedulerContext);
  const [selectedDataApi] = useState([]);
  const { selectedData } = values;
  //let selectedDataApi = [];

  const getDispatchFee = async () => {
    Object.keys(schedulerData.offeredJobs).forEach((keys) => {
      //console.log(schedulerData.offeredJobs[keys])
      Object.keys(schedulerData.offeredJobs[keys]).forEach((secondKeys) => {
        let service = schedulerData.offeredJobs[keys][secondKeys];
        // console.log(selectedData)
        if (
          (secondKeys == selectedData.serviceType.toLowerCase() ||
            secondKeys == selectedData.remType.toLowerCase()) &&
          (service["Universal Job"].toLowerCase() ==
            selectedData.jobType.toLowerCase() ||
            service["Universal Job"].toLowerCase() ==
              selectedData.jobType
                .replace(": Member", "")
                .replace(": Non-Member", "")
                .toLowerCase())
        ) {
          selectedDataApi.push(service);
        }
      });
    });
    // check if dispatch fee 0 or undefined for selected job type
    if (
      selectedDataApi[0]?.dispatchFee === undefined ||
      selectedDataApi[0]?.dispatchFee === 0
    ) {
      // if zero or undefined then skip dispatch free screen during next steps or back steps
      if (clickMode === "next") {
        _handleNext();
      } else if (clickMode === "back") {
        _handleBack();
      }
    }
  };

  useEffect(() => {
    getDispatchFee();
  }, []);

  useEffect(() => {
    if (isChecked) {
      setIsNextdisabled(false);
    } else {
      setIsNextdisabled(true);
    }
    setFieldValue("diagnosticFee", isChecked);
  }, [isChecked]);

  return (
    <div className={classes.formDivWithHeight}>
      <Box component="p" variant="p" className={classes.textBreadcrumb}>
        {`${selectedData?.service} - ${selectedData?.serviceType} - ${selectedData?.serviceCategory} `}
      </Box>
      <Typography variant="h6" className={classes.headingSix}>
        {/*     This visit requires a diagnostic fee of{" "} */}
        {selectedDataApi[0]?.dispatchFeeHeader} {"$"}
        {selectedDataApi[0]?.dispatchFee}
        <hr
          className={classes.titleHr}
          style={{
            marginLeft: "0px",
          }}
        ></hr>
      </Typography>

      <div style={{ width: "100%", margin: "auto", marginTop: "1rem" }}>
        <Box
          component="p"
          variant="p"
          style={{
            color: "#4D4F59",
            fontWeight: "normal",
            fontSize: "1rem",
            lineHeight: "2rem",
          }}
        >
          {selectedDataApi[0]?.dispatchFeeBody}
        </Box>
      </div>
      <Box
        component="div"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "row",
          paddingTop: "1.375rem",
        }}
      >
        <CheckboxField
          value={isChecked}
          className={classes.checkBoxClass}
          defaultChecked={isChecked}
          onChange={() => setIschecked(!isChecked)}
          name="DiagnosticFee"
          label={selectedDataApi[0]?.dispatchFeeDisclaimer}
        />
      </Box>
    </div>
  );
};
export default DiagnosticFeeStep;
